import { Form, Input, InputType } from "decorator-form";

@Form({title:"Image Slider Config"})
export default class ImageSliderConfig {
    

    @Input({type: InputType.TEXT, title:"Width"})
    public width?: string = "100%";

    @Input({type: InputType.TEXT, title:"Height"})
    public height?: string = "200px";

    @Input({type: InputType.STRING_ARRAY, title:"Image URLs"})
    public urls: string[];

   
}


// WEBPACK FOOTER //
// ./src/panels/imageSlider/ImageSliderConfig.ts